import { CookieNamesEnum } from '@/enums/CookieNamesEnum'
import { getCookie } from '@/helpers/getCookie'
import { getImpersonatedCustomerType } from '@/helpers/getCustomerType'
import { resolveSiteContext } from '@/lib/tenant/resolveSiteContext'

import type { Session } from 'next-auth'
import type { SiteContextModeEnum } from '@/enums/SiteContextModeEnum'
import type { SiteContextTenant } from '@/lib/tenant/resolveSiteContext'

/**
 * A customer always shops on the site of their own type; during ASM impersonation that is the impersonated customer.
 * Guests and employees without an impersonated customer use a valid `site` cookie, then the tenant's default site.
 */
export const getRequestSiteContext = (
  tenant: SiteContextTenant,
  session?: Session | null,
  serverCookies?: string,
  requestedSite: string | null = getCookie(CookieNamesEnum.Site, serverCookies)
): SiteContextModeEnum => {
  const customerType = getImpersonatedCustomerType(session, serverCookies) ?? session?.user?.customerType

  return resolveSiteContext(tenant, customerType?.toLowerCase(), requestedSite?.toLowerCase())
}
